// import gettingDetails from "../DataFetching/gettingDetails";

export default function dataStored(key, value) {
  //encryptiong and decryption will do that later.

  sessionStorage.setItem(key, JSON.stringify(value));
}
